// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Please use https://www.color-name.com/ if you need color name */

:root {
  --bright-ruby: #dd359c;
  --light-ruby: #ea99cc;
  --transparent-ruby: rgba(199, 1, 127, 0.1);
  --ruby: #c7017f;
  --dark-ruby: #9b0263;
  --purple: #4d3386;
  --dark-purple: #34235b;
  --midnight-purple: #0f0a1b;
  --blue: #1988c4;
  --yellow: #f9b233;
  --transparent-yellow: rgba(249, 178, 51, 0.1);
  --grey-400: #65626d;
  --grey-300: #9f9da4;
  --grey-200: #c5c4c8;
  --grey-100: #f8f8f8;
  --grey-50: #f5f5f6;
  --grey-80: #808080;
  --white: #fff;
  --white-04: rgba(255, 255, 255, 0.4);
  --white-088: rgba(255, 255, 255, 0.88);
  --white-012: rgba(255, 255, 255, 0.12);
  --black-012: rgba(0, 0, 0, 0.12);
  --black-008: rgba(0, 0, 0, 0.08);
  --black: #000;
  --purple-07: rgba(77, 51, 134, 0.7);
  --midnight-purple-032: rgba(15, 10, 27, 0.32);
  --error-red: #f00;
  --error-404-red: #e50056;
  --biege: #fcf3d6;
  --whitesmoke: #f3f0fa;
  --classic-rose: #f1c2e0;
  --vivid-cerise: #d51b80;
  --light-grey: #bdbdbd;
  --red-violet: #c6017e;
  --lavender-blush: #f8e8f6;
  --green: #25bb00;
  --green-hover: #73bf60;
  --pdp-orange: #e94e1b;
  --pdp-orange-hover: #ea6f46;
  --peacock-green: #40bc21;

  /* CK */

  --brand-primary: #a5924d;
  --brand-secondary: #1b1c22;
  --brand-tertiary: #d7d7ff;
  --neutral-01: #fff;
  --neutral-02: #f8f8f8;
  --neutral-03: #c5c4c8;
  --neutral-04: #9f9da4;
  --neutral-05: #65626d;
  --neutral-06: #0f0a1b;
  --action-CTA-primary-default: #a5924d;
  --action-CTA-primary-disabled: #dbd4b9;
  --action-CTA-primary-tap: #9f841f;
  --action-CTA-secondary-default: #1b1c22;
  --action-CTA-secondary-tap: #000;
  --action-CTA-secondaryWarning-tap: #ff4a4a;
  --promo-background: #f25663;
  --creamy: #f1e5c5;
  --ck-doubler-yellow: #ffec99;

  /* GCS */

  --orange: #ff6950;
  --light-orange: #ff836e;
  --extra-light-orange: #ffa38f;
  --uk-purple: #5800bf;
  --uk-light-purple: #5801bf85;
  --uk-bright-purple: #5801bfd1;
  --uk-dark-purple: #3d0085;
  --magnolia: #f5f0ff;
  --uk-blue: #6fc3ff;
  --beige: #ffecb8;
  --beige-hover: #ffecb8e6;
  --beige-light: #ffecb8a1;
  --pinky: #ffc1c0;
  --light-blue: #bdf1ff;
  --uk-purple-text: #000749;
}
`, "",{"version":3,"sources":["webpack://./src/styles/colors.css"],"names":[],"mappings":"AAAA,kEAAkE;;AAElE;EACE,sBAAsB;EACtB,qBAAqB;EACrB,0CAA0C;EAC1C,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,6CAA6C;EAC7C,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,sCAAsC;EACtC,sCAAsC;EACtC,gCAAgC;EAChC,gCAAgC;EAChC,aAAa;EACb,mCAAmC;EACnC,6CAA6C;EAC7C,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;EAC3B,wBAAwB;;EAExB,OAAO;;EAEP,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qCAAqC;EACrC,sCAAsC;EACtC,iCAAiC;EACjC,uCAAuC;EACvC,gCAAgC;EAChC,0CAA0C;EAC1C,2BAA2B;EAC3B,iBAAiB;EACjB,4BAA4B;;EAE5B,QAAQ;;EAER,iBAAiB;EACjB,uBAAuB;EACvB,6BAA6B;EAC7B,oBAAoB;EACpB,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B","sourcesContent":["/* Please use https://www.color-name.com/ if you need color name */\n\n:root {\n  --bright-ruby: #dd359c;\n  --light-ruby: #ea99cc;\n  --transparent-ruby: rgba(199, 1, 127, 0.1);\n  --ruby: #c7017f;\n  --dark-ruby: #9b0263;\n  --purple: #4d3386;\n  --dark-purple: #34235b;\n  --midnight-purple: #0f0a1b;\n  --blue: #1988c4;\n  --yellow: #f9b233;\n  --transparent-yellow: rgba(249, 178, 51, 0.1);\n  --grey-400: #65626d;\n  --grey-300: #9f9da4;\n  --grey-200: #c5c4c8;\n  --grey-100: #f8f8f8;\n  --grey-50: #f5f5f6;\n  --grey-80: #808080;\n  --white: #fff;\n  --white-04: rgba(255, 255, 255, 0.4);\n  --white-088: rgba(255, 255, 255, 0.88);\n  --white-012: rgba(255, 255, 255, 0.12);\n  --black-012: rgba(0, 0, 0, 0.12);\n  --black-008: rgba(0, 0, 0, 0.08);\n  --black: #000;\n  --purple-07: rgba(77, 51, 134, 0.7);\n  --midnight-purple-032: rgba(15, 10, 27, 0.32);\n  --error-red: #f00;\n  --error-404-red: #e50056;\n  --biege: #fcf3d6;\n  --whitesmoke: #f3f0fa;\n  --classic-rose: #f1c2e0;\n  --vivid-cerise: #d51b80;\n  --light-grey: #bdbdbd;\n  --red-violet: #c6017e;\n  --lavender-blush: #f8e8f6;\n  --green: #25bb00;\n  --green-hover: #73bf60;\n  --pdp-orange: #e94e1b;\n  --pdp-orange-hover: #ea6f46;\n  --peacock-green: #40bc21;\n\n  /* CK */\n\n  --brand-primary: #a5924d;\n  --brand-secondary: #1b1c22;\n  --brand-tertiary: #d7d7ff;\n  --neutral-01: #fff;\n  --neutral-02: #f8f8f8;\n  --neutral-03: #c5c4c8;\n  --neutral-04: #9f9da4;\n  --neutral-05: #65626d;\n  --neutral-06: #0f0a1b;\n  --action-CTA-primary-default: #a5924d;\n  --action-CTA-primary-disabled: #dbd4b9;\n  --action-CTA-primary-tap: #9f841f;\n  --action-CTA-secondary-default: #1b1c22;\n  --action-CTA-secondary-tap: #000;\n  --action-CTA-secondaryWarning-tap: #ff4a4a;\n  --promo-background: #f25663;\n  --creamy: #f1e5c5;\n  --ck-doubler-yellow: #ffec99;\n\n  /* GCS */\n\n  --orange: #ff6950;\n  --light-orange: #ff836e;\n  --extra-light-orange: #ffa38f;\n  --uk-purple: #5800bf;\n  --uk-light-purple: #5801bf85;\n  --uk-bright-purple: #5801bfd1;\n  --uk-dark-purple: #3d0085;\n  --magnolia: #f5f0ff;\n  --uk-blue: #6fc3ff;\n  --beige: #ffecb8;\n  --beige-hover: #ffecb8e6;\n  --beige-light: #ffecb8a1;\n  --pinky: #ffc1c0;\n  --light-blue: #bdf1ff;\n  --uk-purple-text: #000749;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
